import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { fireAndForget, isNativeApp } from "@/lib/safeDespia";
import { initAnalytics } from "@/lib/analytics";

try {
  initAnalytics();
} catch (e) {
  console.error("analytics init failed", e);
}

// Detect Despia native app and set data attribute for CSS overrides (iPad support)
try {
  if (isNativeApp()) {
  document.documentElement.setAttribute("data-native", "true");

  const applyNativeStatusBar = () => {
    const isDark = document.documentElement.classList.contains("dark");
    if (isDark) {
      // Dark mode: deep blue bar with white text
      document.documentElement.style.backgroundColor = "hsl(222 47% 6%)";
      document.body.style.backgroundColor = "hsl(222 47% 6%)";
      fireAndForget("statusbarcolor://{10, 14, 26}");
      fireAndForget("statusbartextcolor://white");
    } else {
      // Light mode: white bar with dark text
      document.documentElement.style.backgroundColor = "#ffffff";
      document.body.style.backgroundColor = "#ffffff";
      fireAndForget("statusbarcolor://{255, 255, 255}");
      fireAndForget("statusbartextcolor://black");
    }
  };

  applyNativeStatusBar();

  // Re-apply if the theme class changes at runtime
    const observer = new MutationObserver(applyNativeStatusBar);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  }
} catch (e) {
  console.error("native bootstrap failed", e);
}

createRoot(document.getElementById("root")!).render(<App />);

// Tell the boot watchdog in index.html that React mounted successfully.
window.dispatchEvent(new Event("spotrai:mounted"));
